import { Component, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { AddBannerAction } from "../banners.actions";
import { Image } from "../../../shared/image-uploader/image.interface";
import { ImageService } from "../../../shared/image-uploader/image.service";
import { MatDialogRef } from "@angular/material/dialog";
import { AddBannerObject } from "../banners.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../../shared/error-state-matcher";

@Component({
  selector: "app-banner-add",
  templateUrl: "./banner-add.component.html",
  styleUrls: ["./banner-add.component.scss"],
  standalone: false,
})
export class BannerAddComponent implements OnInit {
  file;
  public form: UntypedFormGroup;
  saving = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();
  private readonly MAX_PREVIEW_WIDTH = 500;

  constructor(
    private store: Store,
    public imageService: ImageService,
    private dialogRef: MatDialogRef<BannerAddComponent>,
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = (): void => {
    this.form = new UntypedFormGroup({
      file: new UntypedFormControl("", (c) => Validators.required(c)),
      name: new UntypedFormControl("", (c) => Validators.required(c)),
      url: new UntypedFormControl("", (c) => Validators.required(c)),
      utm: new UntypedFormControl("gsignature", (c) => Validators.required(c)),
      imageWidth: new UntypedFormControl("", (c) => Validators.min(0)(c)),
      imageHeight: new UntypedFormControl("", (c) => Validators.min(0)(c)),
      originalImageWidth: new UntypedFormControl("", (c) =>
        Validators.min(0)(c),
      ),
      originalImageHeight: new UntypedFormControl("", (c) =>
        Validators.min(0)(c),
      ),
    });
  };

  onSubmit = (): void => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.saving || this.form.invalid) {
      return;
    }
    this.saving = true;
    const formValue = this.form.value as AddBannerObject;
    this.store.dispatch(new AddBannerAction(formValue));
    this.dialogRef.close(true);
  };

  fileChange = (file: Image): void => {
    this.file = file.file;
    const formValue = this.form.value as {
      originalImageWidth?: number;
      originalImageHeight?: number;
    };
    const originalWidth = file.width || formValue.originalImageWidth || 0;
    const originalHeight = file.height || formValue.originalImageHeight || 0;

    const previewWidth = Math.min(originalWidth, this.MAX_PREVIEW_WIDTH);
    const previewHeight =
      originalWidth > 0 ? (previewWidth / originalWidth) * originalHeight : 0;

    this.form.patchValue({
      file: file.file,
      originalImageWidth: String(originalWidth),
      originalImageHeight: String(originalHeight),
      imageWidth: String(previewWidth),
      imageHeight: String(previewHeight),
    });
  };

  removeFile = (): void => {
    this.file = null;
    this.form.patchValue({
      file: "",
      imageWidth: "",
      imageHeight: "",
      originalImageWidth: "",
      originalImageHeight: "",
    });
  };

  cancel = (): void => {
    this.fillInitialForm();
    this.dialogRef.close();
  };
}
